const useGetHeaderText = (location: string) => {
  let heading;
  let text;
  switch (location) {
    case "/":
      heading = "Dashboard";
      text = "View stats, insights, and suggestions to improve performance.";
      break;
    case "/chats":
      heading = "Chats";
      text =
        "Manage conversations with customers, agents, and managers easily.";
      break;
    case "/users":
      heading = "Users";
      text = "View and manage user accounts, roles, and permissions.";
      break;
    case "/reports":
      heading = "Reports";
      text = "Access reports and performance metrics to analyze progress.";
      break;
    // Lock all settings and its subroutes to show Settings heading and text
    default:
      if (location.startsWith("/settings")) {
        heading = "Settings";
        text =
          "Configure preferences and manage your platform settings easily.";
      } else {
        heading = "Kuikwit";
        text = "See chats with customers, managers, agents and more.";
      }
      break;
  }
  return { heading, text };
};

export default useGetHeaderText;
